module.exports = __webpack_public_path__ + "themes/fq/img/frame.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/frame.png
// module id = 61
// module chunks = d-game